<template>
    <v-container>
        <module-bar :title="title" icon="mdi-cash-clock" />
        <v-card outlined>
            <v-card-text>
                <v-form v-model="valid" ref="form">
                    <v-row>
                        <v-col cols="12" md="6">
                            <v-select label="Ubicacion" :items="locations" v-model="locationId" item-value="id"
                                item-text="name" :rules="rulesLocation" :loading="loadingLocation" />
                        </v-col>

                        <v-col cols="12" md="6">
                            <v-text-field v-model="amountBill" label="Monto de Gastos" type="number" />
                        </v-col>

                        <v-col cols="12">
                            <v-textarea label="Descripcion" outlined v-model="description" />
                        </v-col>

                        <v-col cols="6" class="d-flex justity-start">
                            <v-btn text color="primary" @click="openDialogEmployee">agregar empleados</v-btn>
                        </v-col>



                        <v-col cols="6" class="d-flex justify-end" style="font-size: large;">
                            SUELDO TOTAL:
                            {{
                                salaryTotal.toLocaleString('es-PE', { style: 'currency', currency: 'PEN' })
                            }}
                        </v-col>
                        <v-col>
                            <v-list>
                                <template v-for="(employee, key) in employeeSelected">
                                    <v-list-item :key="key" v-if="employeeSelected.length > 0">
                                        <v-list-item-avatar>
                                            <v-img :src="employee.photo_url ? employee.photo_url : photoEmpty"
                                                :lazy-src="employee.photo_thumb_url ? employee.photo_thumb_url : photoEmpty" />
                                        </v-list-item-avatar>
                                        <v-list-item-content>
                                            <v-list-item-title>{{ employee.names }} /
                                                {{ employee.last_names }}</v-list-item-title>
                                            <v-list-item-subtitle>{{ employee.avatar }}</v-list-item-subtitle>
                                            <v-list-item-subtitle>{{ employee.salary.toLocaleString('es-PE', {
                                                style:
                                                    'currency', currency: 'PEN'
                                            }) }}</v-list-item-subtitle>
                                        </v-list-item-content>
                                        <v-list-item-action>
                                            <v-btn @click="changeLider(key)" icon><v-icon
                                                    :color="employee.is_lider == 1 ? `orange` : `default`">mdi-crown-outline</v-icon></v-btn>
                                        </v-list-item-action>
                                        <v-list-item-action>
                                            <v-btn icon @click="deleteEmployee(key)">
                                                <v-icon>mdi-delete</v-icon>
                                            </v-btn>
                                        </v-list-item-action>
                                    </v-list-item>
                                    <v-divider v-if="key != employeeSelected.length - 1" :key="`div${key}`" />
                                </template>
                            </v-list>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-btn v-if="schema == 'edit'" @click="deletePayroll" color="red" text>eliminar nomina</v-btn>
                <v-spacer></v-spacer>
                <v-btn v-if="schema == 'edit'" @click="closeDialogPayroll" color="default" text>cancelar</v-btn>
                <v-btn :loading="loadingProcess" @click="process" color="primary" text>{{ btnText }}</v-btn>
            </v-card-actions>
        </v-card>

        <v-dialog width="800" v-model="dialogEmployees" persistent max-height="600">
            <search-employee @closeDialogSearchEmployee="closeDialogSearchEmployee" :employeeSelected="employeeSelected"
                :lider="lider" :searchAll="false" @addEmployee="addEmployee" />
        </v-dialog>
    </v-container>
</template>

<script>
import ModuleBar from '../General/ModuleBar.vue';
import photoEmpty from "../../assets/profile.jpeg";
import bus from "../../events/bus.js";
import searchEmployee from './searchEmployee.vue';

export default {
    components: { ModuleBar, searchEmployee },

    beforeMount() {
        if (this.payroll) {
            this.loadPayroll();
        }
        this.loadLocations();
    },

    props: {
        title: {
            type: String,
            required: true
        },
        schema: {
            type: String,
            required: true
        },
        payroll: {
            type: Object,
            default: null
        },
        click: {
            type: Number,
            default: null
        }
    },

    data() {
        return {
            description: "",
            enabledAutocompleteLider: false,
            liderAux: null,
            locations: [],
            loadingLocation: false,
            locationId: 0,
            searchLider: null,
            liders: [],
            loadingLider: false,
            observation: '',
            amountBill: 0,
            salaryTotal: 0,
            employeeSelected: [],
            photoEmpty: photoEmpty,
            loadingSearchEmployee: false,
            valid: false,
            btnText: 'Aceptar',
            lider: 0,
            location: '',
            payrollCount: 0,
            payrollAmount: 0,
            loadingProcess: false,
            payrollId: 0,
            loadingDelete: false,
            employees: [],
            dialogEmployees: false,

            rulesLider: [
                v => !!v || 'El campo Lider es requerido',
            ],
            rulesLocation: [
                (value) => (value && value > 0) || "Seleccione la ubicacion",
            ],
        };
    },

    watch: {

        location(value) {
            this.location = value.toUpperCase();
        },

        click() {
            this.loadPayroll();
        },

    },

    methods: {
        process() {
            if (this.$refs.form.validate()) {
                let existLider = this.employeeSelected.find(l => l.is_lider);
                if (!existLider) {
                    bus.$emit("snackbar", {
                        color: "red",
                        text: "EL lider es requerido",
                    });
                    return;
                }

                this.loadingProcess = true;
                setTimeout(() => {
                    const path = this.schema == 'edit' ? 'payrollUpdateAction' : 'payrollStoreAction';

                    let ids = "";
                    this.employeeSelected.forEach(element => {
                        ids += element.id + ","
                    });
                    ids += "0";

                    const data = {
                        lider_id: this.employeeSelected.find(l => l.is_lider).id,
                        location_id: this.locationId,
                        amount_bill: this.amountBill ? this.amountBill : 0,
                        description: this.description,
                        ids: ids,
                    };

                    if (this.schema == 'edit') {
                        data.id = this.payrollId;
                    }

                    this.$store.dispatch(path, data)
                        .then((res) => {
                            this.loadingProcess = false;

                            if (this.schema == 'edit') {
                                res.action = "edit";
                                res.location = { id: res.location_id, name: this.locations.find(l => l.id == res.location_id).name };
                                this.closeDialogPayroll(res);
                            } else {
                                this.clear();
                            }
                            this.clear();
                        })
                        .catch(error => {
                            this.loadingProcess = false;
                            console.error('Error creating payroll:', error);
                        });
                }, 500);

            } else {
                this.$refs.form.validate();
            }
        },

        clear() {
            this.liders = [];
            this.employeeSelected = [];
            this.salaryTotal = 0;
            this.locationId = 0;
            this.amountBill = 0;
            this.lider = 0;
            this.location = '';
            this.payrollCount = 0;
            this.payrollAmount = 0;
            this.description = '';
            this.$refs.form.resetValidation();
        },

        loadPayroll() {
            this.payrollId = this.payroll.id;
            this.locationId = this.payroll.location_id;
            this.amountBill = this.payroll.amount_bill;
            this.description = this.payroll.description;
            this.btnText = 'Editar';

            if (this.payroll.employees.length) {
                let result = this.payroll.employees.find(l => l.is_lider);

                this.liderAux = {
                    id: result.id,
                    names: `${result.names} / ${result.last_names} / ${result.avatar}`,
                    photo_url: result.photo_url,
                    photo_thumb_url: result.photo_thumb_url,
                    salary: result.salary
                }

                this.employeeSelected = this.payroll.employees;
                this.totals();
            }
        },

        deletePayroll() {
            this.$confirm({
                message: `Quieres eliminar esta nomina?`,
                button: {
                    no: "No",
                    yes: "Si",
                },
                callback: (confirm) => {
                    if (confirm) {
                        this.loadingDelete = true;
                        setTimeout(() => {
                            this.$store
                                .dispatch("deletePayrollAction", { id: this.payrollId })
                                .then(() => {
                                    this.loadingDelete = false;
                                    let payload = {
                                        action: "delete",
                                        id: this.payrollId
                                    };

                                    this.closeDialogPayroll(payload);
                                });
                        }, 500);
                    }
                },
            });
        },

        openDialogEmployee() {
            this.dialogEmployees = true;
        },

        searchEmployee() {
            if (this.args.length >= 3) {
                this.loadingSearchEmployee = true;
                this.employees = [];
                let ids = "";

                this.employeeSelected.forEach(element => {
                    ids += element.id + ","
                });

                if (this.lider) {
                    ids += this.lider + ",";
                }
                ids += "0";

                setTimeout(() => {
                    this.$store.dispatch("findEmployessNoPayRollAction", { args: this.args, ids: ids }).then((res) => {
                        this.loadingSearchEmployee = false;
                        this.employees = res;
                    })
                }, 500);
            }
        },

        totals() {
            this.salaryTotal = 0;
            this.employeeSelected.forEach(element => {
                this.salaryTotal += element.salary;
            });

            if (this.liderAux) {
                this.salaryTotal += this.liderAux.salary;
            }
        },

        deleteEmployee(key) {
            //let employee = this.employeeSelected[key];
            this.employeeSelected.splice(key, 1);

            // if (this.schema == 'edit') {
            //     this.$emit("deleteOneEmployee", employee)
            // }

            this.totals();
        },

        closeDialogPayroll(res) {
            this.$emit("closeDialogPayroll", res)
        },

        closeDialogEmployee() {
            this.dialogEmployees = false;
            this.args = null;
            this.employees = [];
        },

        clearLider() {
            this.loadingLider = false;
            let index = this.liders.findIndex(lider => lider.id == this.lider);
            if (index != -1) {
                this.salaryTotal -= this.liders[index].salary;
            }
            this.liders = [];
        },

        loadLocations() {
            this.loadingLocation = true;
            setTimeout(() => {
                this.$store.dispatch("findLocations").then((res) => {
                    this.locations = res;
                    this.loadingLocation = false;
                });
            }, 500);
        },

        enabledEditLider() {
            if (this.schema == 'edit') {
                this.enabledAutocompleteLider = true;
            } else {
                this.enabledAutocompleteLider = false;
            }
        },

        changeLider(index) {
            this.employeeSelected.forEach(element => {
                this.$set(element, 'is_lider', 0);
            });

            this.$set(this.employeeSelected[index], 'is_lider', 1);
        },

        closeDialogSearchEmployee() {
            this.dialogEmployees = false;
        },

        addEmployee(employee) {
            this.employeeSelected.push(employee);
            this.totals();
        },
    }
};

</script>